import { Component, OnInit, Input } from '@angular/core';
import { WebcamImage, WebcamInitError } from 'ngx-webcam';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DaytranService } from 'src/providers/daytran-ervice/daytran.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { Http, ResponseContentType } from '@angular/http';

@Component({
  selector: 'app-snap-shot',
  templateUrl: './snap-shot.component.html',
  styleUrls: ['./snap-shot.component.scss']
})
export class SnapShotComponent implements OnInit {
  public webcamImage: WebcamImage = null;
  public errors: WebcamInitError[] = [];
  @Input() public empno;
  @Input() public type;
  currentEmpNo;
  currentType;
  noImageAvaiable;
  constructor(
    public activeModal: NgbActiveModal,
    private daytranService: DaytranService,
    private http: Http,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) { }

  async ngOnInit(): Promise<void> {
    this.currentEmpNo = this.empno;
    this.currentType = this.type;
    const res: Blob = await this.http.get('/assets/noCamera.jpg', { responseType: ResponseContentType.Blob }).toPromise()
      .then(resp => resp.json() as Blob);
    const reader = new FileReader();
    reader.readAsDataURL(res);
    reader.onloadend = () => {
      this.noImageAvaiable = reader.result;
    }

  }

  handleImage(webcamImage: WebcamImage) {
    this.webcamImage = webcamImage;
  }

  handleInitError(error: WebcamInitError) {
    this.errors.push(error);
  }

  close() {
    this.activeModal.dismiss();
  }

  async submit(): Promise<void> {
    let logImage;
    if (this.errors.length === 0) {
      if (!this.webcamImage) {
        this.toastr.error('Capture Image First!');
        return
      } else {
        logImage = this.webcamImage.imageAsDataUrl
      }
    } else {
      logImage = this.noImageAvaiable;
    }

    this.spinner.show();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const body = {
          in_out: this.currentType,
          empcode: this.currentEmpNo,
          longitude: position.coords.longitude,
          latitude: position.coords.latitude
        };

        this.daytranService.sendDaytran(body, logImage).then(async next => {
          if (next.success === 1) {
            await this.spinner.hide();
            this.toastr.success(next.message, next.employee);
            this.activeModal.close();
          } else {
            await this.spinner.hide();
            this.toastr.error(next.message);
            this.activeModal.close();
          }
        });
      });
    }
  }
}
